import React, { useContext, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";
import { images } from "../../Assets/images";
import { apiEndPoints } from "../../Url";

const ArticlesDetails = () => {
  const { getArticleDetailsByID, articleDetails, translatedLabels } =
    useContext(GlobalContext);
  const { id } = useParams();
  const screenLabels = translatedLabels?.common;
  const authLabel = translatedLabels?.auth;

  useEffect(() => {
    getArticleDetailsByID(id);
  }, [id, getArticleDetailsByID]);

  const aricleDetailData = articleDetails || {};
  return (
    <div className="content-part mb-3 text-break">
      {aricleDetailData ? (
        <div>
          <h5 className="mb-2">{aricleDetailData?.name}</h5>
          <h6 className="mb-1">
            {Array.isArray(aricleDetailData?.category)
              ? aricleDetailData?.category
                .map((cat) => {
                  const key = cat
                    .trim()
                    .toLowerCase()
                    .replace(/ & /g, "_")
                    .replace(/ /g, "_");
                  return authLabel?.[key]?.label_value || cat.trim();
                })
                .join(", ")
              : aricleDetailData?.category || ""}
          </h6>

          <p className="">
            {screenLabels?.author?.label_value || "Author"}:{" "}
            <span className="font-600">{aricleDetailData?.author}</span>
          </p>

          <div className="article-details-image">
            <img
              src={
                aricleDetailData?.image
                  ? apiEndPoints +
                  "/uploads/article_img/" +
                  aricleDetailData.image
                  : images.placeHolderImg
              }
              alt={aricleDetailData?.name}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = images.placeHolderImg;
              }}
            />
          </div>
          <p
            id="articleDetails"
            className="mt-3 mb-0"
            dangerouslySetInnerHTML={{ __html: aricleDetailData.content }}
          />
          <div className="d-flex justify-content-center align-items-center">
            <Link
              to="/articles"
              className="btn btn-primary mt-3 mb-3 text-center mx-auto linkColor"
            >
              {screenLabels?.back_to_articles?.label_value ||
                "Back to Articles"}
            </Link>
          </div>
        </div>
      ) : (
        <div className="text-center mt-3">
          {screenLabels?.article_not_found?.label_value || "Article not found"}
        </div>
      )}
    </div>
  );
};

export default ArticlesDetails;
